import type { NewsResponse } from '../../types/news'

export type NewsEdition = 'ai' | 'robots' | 'cybersecurity'
const endpoints: Record<NewsEdition, string> = {
  ai: import.meta.env.VITE_NEWS_API_URL || '/api/news',
  robots: import.meta.env.VITE_ROBOT_NEWS_API_URL || '/api/robot-news',
  cybersecurity: import.meta.env.VITE_CYBER_NEWS_API_URL || '/api/cyber-news',
}

export async function getLatestNews(signal?: AbortSignal, edition: NewsEdition = 'ai'): Promise<NewsResponse> {
  const response = await fetch(endpoints[edition], { signal, cache: 'no-cache', headers: { Accept: 'application/json' } })
  if (!response.ok) throw new Error(`News service returned ${response.status}`)
  return await response.json() as NewsResponse
}
